import { render, staticRenderFns } from "./funAuthorization.vue?vue&type=template&id=51291c04&scoped=true"
import script from "./funAuthorization.vue?vue&type=script&lang=js"
export * from "./funAuthorization.vue?vue&type=script&lang=js"
import style0 from "./funAuthorization.vue?vue&type=style&index=0&id=51291c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51291c04",
  null
  
)

export default component.exports